import * as orgActions from '~/actions/org';

export const UPDATE_ME = 'UPDATE_ME';

export const updateMe = (me = {}) => dispatch => {
  if (window.snowplow) {
    window.snowplow('setUserId', me.id);
  }

  if (me.organization) {
    dispatch(orgActions.updateOrg(me.organization));
  }

  dispatch(updateMeDispatch(me));
};

export const updateMeDispatch = me => ({
  type: UPDATE_ME,
  me,
  isLoggedIn: true,
});

export const clearMe = () => {
  return {
    type: UPDATE_ME,
    me: {},
    isLoggedIn: false,
  };
};
